import { useState } from 'react'
import { STAGING_LOAN } from '../../../config/env';
import { FormInput, FormSelect, FormRadio, Button } from "components";
// `sortSubSectorOpts` is a helper function, not data — keep it local.
import { sortSubSectorOpts } from "components/misc/constants";
import useConfigOptions from 'hooks/useConfigOptions';
import { fetchRequests } from 'https/requests';
import { useUser } from 'hooks';
import { useDispatch } from 'react-redux';
import { show } from 'providers/toastSlice';
import { useNavigate } from 'react-router-dom';

function BusinessReg() {

    const { accessToken } = useUser();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        customerTypeOpts, otherFinancialOpts, businessTypeOpts, businessActivityOpts,
        businessSectorOpts, employmentLevelOpts, employmentTypeOpts,
        employmentNatureOpts, demandGoodsOpts,
    } = useConfigOptions();

    const [name, setName] = useState('');
    const [owner, setOwner] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [location, setLocation] = useState('');
    const [phones, setPhones] = useState('');
    const [type, setType] = useState('');
    const [establishDate, setEstablishDate] = useState('');
    const [owners, setOwners] = useState('');
    const [busActivities, setBusActivities] = useState('');
    const [sector, setSector] = useState('');
    const [subsector, setSubsector] = useState('');
    const [incomeSource, setIncomeSource] = useState('');
    const [accountOperators, setAccountOperators] = useState('');
    const [assets, setAssets] = useState('');
    const [employLevel, setEmployLevel] = useState('');
    const [employType, setEmployType] = useState('');
    const [employNature, setEmployNature] = useState('');
    const [goodsDemand, setGoodsDemand] = useState('');
    const [customerTypes, setCustomerTypes] = useState([]);
    const [otherFinancial, setOtherFinancial] = useState([]);
    const [processing, setProcessing] = useState(false);

    const handleSubmit = async(e) => {
        e.preventDefault();
        setProcessing(true);

        let data = { name, owner, email, address, location, phones, type, establishDate, owners, busActivities, sector, subsector, incomeSource, accountOperators, assets, employLevel, employType, employNature, goodsDemand, customerTypes, otherFinancial }

        let url = `${STAGING_LOAN}/register-business`;
        let headers = {
            "Content-Type": "application/json",
            "Authorization" : `${accessToken}`
        }
        
        let res = await fetchRequests(url, "post", headers, {}, data);
        setProcessing(false);

        if(res?.code === 401){
			navigate("/login");
            dispatch(show({
                state : true,
                message : `Your session has expired, please login to continue.`,
                type : "token"
            }))
            return;
        }

        if(res?.err){
            dispatch(show({
                state : true,
                message : `${res?.err}`,
                type : "error"
            }))
            return;
        }
        
        if(res?.message){
            dispatch(show({
                state : true,
                message : `${res?.message}`,
                type : "success"
            }))
        }

        setTimeout(() => {
            window.location.reload();
        }, 3000);
    }

    return (
        <form className='space-y-6' onSubmit={handleSubmit}>
            <h2 className='mt-10 mb-2 dark:text-slate-200 text-lg'>Details</h2>

            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 md:grid-cols-2 lg:grid-cols-3">
                <FormInput 
                    label="Name of Business"
                    type="text"
                    placeholder="Business Name"
                    id={"name"}
                    name={"name"}
                    value={name}
                    setValue={setName}
                    required={true}
                />

                <FormInput 
                    label="Owner's Phone Number"
                    inputMode='numeric'
                    pattern='[0-9]*'
                    placeholder="Owner's Phone Number"
                    id={"owner"}
                    name={"owner"}
                    value={owner}
                    setValue={setOwner}
                    required={true}
                />

                <FormInput 
                    label="Email address"
                    type="text"
                    placeholder="Business email address"
                    id={"email"}
                    name={"email"}
                    value={email}
                    setValue={setEmail}
                    required={true}
                />

                <FormInput 
                    label="Address"
                    type="text"
                    placeholder="Business address"
                    id={"address"}
                    name={"address"}
                    value={address}
                    setValue={setAddress}
                    required={true}
                />

                <FormInput 
                    label="Location (If different from address)"
                    type="text"
                    placeholder="Business address"
                    id={"location"}
                    name={"location"}
                    value={location}
                    setValue={setLocation}
                    required={true}
                />

                <FormInput 
                    label="Phone Numbers"
                    type="text"
                    placeholder={"(numbers, separated by commas)"}
                    id={"phones"}
                    name={"phones"}
                    value={phones}
                    setValue={setPhones}
                    required={true}
                />

                <FormSelect 
                    label='Type of Business'
                    name={"type"}
                    id={"type"}
                    content={businessTypeOpts}
                    value={type}
                    setValue={setType}
                    required={true}
                />

                <div>
                    <label htmlFor="establishDate" className='form-label'>
                        Date of Business Establishment
                    </label>
                    <input 
                        type="date"
                        name={"establishDate"}
                        id={"establishDate"}
                        className="form-input disabled:opacity-75 disabled:bg-gray-200 placeholder:text-gray-700 disabled:cursor-not-allowed"
                        value={establishDate}
                        onChange={e => setEstablishDate(e.target.value)}
                        min={new Date("1950-01-01").toISOString().split('T')[0]}
                        max={new Date().toISOString().split('T')[0]}
                        required={true}
                    />
                </div>

                <FormInput 
                    label="Business Owners"
                    type="text"
                    placeholder={"(names, separated by commas)"}
                    id={"owners"}
                    name={"owners"}
                    value={owners}
                    setValue={setOwners}
                    required={true}
                />

                <FormSelect 
                    label='What does your business do?'
                    name={"busActivities"}
                    id={"busActivities"}
                    content={businessActivityOpts}
                    value={busActivities}
                    setValue={setBusActivities}
                    required={true}
                />

                <FormSelect 
                    label='Sector of Business'
                    name={"sector"}
                    id={"sector"}
                    content={businessSectorOpts}
                    value={sector}
                    setValue={setSector}
                    required={true}
                />

                <FormSelect 
                    label='Subsector'
                    name={"subsector"}
                    id={"subsector"}
                    content={sortSubSectorOpts(sector)}
                    value={subsector}
                    setValue={setSubsector}
                    required={true}
                />

                <FormInput 
                    label="Bank Account Details"
                    type="text"
                    id={"incomeSource"}
                    name={"incomeSource"}
                    value={incomeSource}
                    setValue={setIncomeSource}
                    required={true}
                />

                <FormInput 
                    label="Those with authority to operate the account"
                    type="text"
                    placeholder={"(names, separated by commas)"}
                    id={"accountOperators"}
                    name={"accountOperators"}
                    value={accountOperators}
                    setValue={setAccountOperators}
                    required={true}
                />

                <FormInput 
                    label="Total assets"
                    type="text"
                    id={"assets"}
                    name={"assets"}
                    value={assets}
                    setValue={setAssets}
                    required={true}
                />

                <FormSelect 
                    label='Employment level'
                    name={"employLevel"}
                    id={"employLevel"}
                    content={employmentLevelOpts}
                    value={employLevel}
                    setValue={setEmployLevel}
                    required={true}
                />

                <FormSelect 
                    label='Employment type'
                    name={"employType"}
                    id={"employType"}
                    content={employmentTypeOpts}
                    value={employType}
                    setValue={setEmployType}
                    required={true}
                />

                <FormSelect 
                    label='Employment nature'
                    name={"employNature"}
                    id={"employNature"}
                    content={employmentNatureOpts}
                    value={employNature}
                    setValue={setEmployNature}
                    required={true}
                />

                <FormSelect 
                    label='Demand for goods'
                    name={"goodsDemand"}
                    id={"goodsDemand"}
                    content={demandGoodsOpts}
                    value={goodsDemand}
                    setValue={setGoodsDemand}
                    required={true}
                />

                <div className='grid gap-4 grid-cols-4 col-span-3'>
                    <div className='col-span-2'>
                        <FormRadio 
                            label='Customer Type'
                            type='checkbox'
                            content={customerTypeOpts}
                            value={customerTypes}
                            setValue={setCustomerTypes}
                        />
                    </div>

                    <div className='col-span-2'>
                        <FormRadio 
                            label='Other financial institutions'
                            type='checkbox'
                            content={otherFinancialOpts}
                            value={otherFinancial}
                            setValue={setOtherFinancial}
                        />
                    </div>
                </div>

                <div className='col-span-1'>
                    <Button 
                        btnText={"Register"} 
                        btnType={"submit"}
                        btnClasses={"form-button"} 
                        processing={processing}
                    />
                </div>
            </div>
        </form>
    )
}

export default BusinessReg